export default "__VITE_ASSET__Ct2i47AO__"